<template>
  <div>
    <v-container>
      <template>
        <div class="text-center">
          <v-dialog
            v-model="dialog"
            width="707"
            @click:outside="closeModal"
            :retain-focus="false"
          >
            <v-card class="custom-card" rounded="0">
              <v-toolbar color="secondary" class="white--text">
                <v-toolbar-title class="font-weight-bold">
                  {{ titleHeading }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon class="white--text" @click="closeModal">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card
                elevation="0"
                style="padding: 20px"
                v-if="dialogCode == 'specific-gravity'"
              >
                <div class="d-flex">
                  <div class="mr-auto p-2">
                    <v-list
                      style="
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: normal;
                        letter-spacing: 0.8px;
                      "
                    >
                      <v-list-item>
                        <v-list-item-title
                          >Recommended - <b>1.027 - 1.032</b></v-list-item-title
                        >
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title
                          >Your Std. Temperature -
                          <span class="text--success"
                            ><b
                              >{{ acidityRawMilkOrGravityValue }}
                              {{ acidityRawMilkOrGravityResult }}
                            </b></span
                          ></v-list-item-title
                        >
                      </v-list-item>
                    </v-list>
                  </div>
                  <div class="p-2">
                    <v-list>
                      <v-list-item
                        style="
                          color: #2e63a3;
                          font-size: 16px;
                          font-style: normal;
                          font-weight: 400;
                          line-height: 33.492px;
                        "
                      >
                        <template v-slot:prepend>
                          <v-icon icon="mdi-close"></v-icon>
                        </template>
                        <v-list-item-title>Skimming of fats</v-list-item-title>
                      </v-list-item>

                      <v-list-item
                        style="
                          color: #00bd73;
                          font-size: 16px;
                          font-style: normal;
                          font-weight: 400;
                          line-height: 33.492px;
                        "
                      >
                        <template v-slot:prepend>
                          <v-icon icon="mdi-checkbox-blank-circle"></v-icon>
                        </template>

                        <v-list-item-title>Recommended</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        style="
                          color: #9747ff;
                          font-size: 16px;
                          font-style: normal;
                          font-weight: 400;
                          line-height: 33.492px;
                        "
                      >
                        <template v-slot:prepend>
                          <v-icon icon="mdi-checkbox-blank-circle"></v-icon>
                        </template>

                        <v-list-item-title>Addition of water</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </div>
                </div>
                <linear-guage
                  :acidityRawMilkOrGravityValue="acidityRawMilkOrGravityValue"
                  :dialogCode="dialogCode"
                />

                <div class="d-flex flex-column">
                  <div class="p-2" style="margin-left: 16px">
                    <span
                      style="
                        color: #2e63a3;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: normal;
                        letter-spacing: 0.8px;
                      "
                      >Important Note</span
                    >
                    <v-divider style="margin-top: 10px"></v-divider>
                  </div>

                  <div class="p-2" style="margin-left: 16px">
                    <p
                      class="mt-5"
                      style="
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 33.492px;
                      "
                    >
                      The higher value of specific gravity (1.035) indicates
                      skimming of fats whereas the lower value (1.020) is
                      indicative of addition of water.
                    </p>
                  </div>
                </div>
              </v-card>

              <v-card
                elevation="0"
                style="padding: 20px"
                v-if="dialogCode == 'acidity-raw-milk'"
              >
                <div class="d-flex">
                  <div class="mr-auto p-2">
                    <v-list
                      style="
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: normal;
                        letter-spacing: 0.8px;
                      "
                    >
                      <v-list-item>
                        <v-list-item-title
                          >Recommended - <b>6.7 - 6.9</b></v-list-item-title
                        >
                      </v-list-item>
                      <v-list-item>
                        <span
                          >Your pH -
                          <span
                            ><b style="color: #2e63a3"
                              >{{ acidityRawMilkOrGravityValue }}
                              {{ acidityRawMilkOrGravityResult }} pH</b
                            ></span
                          ></span
                        >
                      </v-list-item>
                    </v-list>
                  </div>
                  <div class="p-2">
                    <v-list>
                      <v-list-item
                        style="
                          color: #2e63a3;
                          font-size: 16px;
                          font-style: normal;
                          font-weight: 400;
                          line-height: 33.492px;
                        "
                      >
                        <template v-slot:prepend>
                          <v-icon icon="mdi-close"></v-icon>
                        </template>
                        <v-list-item-title
                          >Presence of colostrum or<br />bacterial
                          contamination.</v-list-item-title
                        >
                      </v-list-item>

                      <v-list-item
                        style="
                          color: #00bd73;
                          font-size: 16px;
                          font-style: normal;
                          font-weight: 400;
                          line-height: 33.492px;
                        "
                      >
                        <template v-slot:prepend>
                          <v-icon icon="mdi-checkbox-blank-circle"></v-icon>
                        </template>

                        <v-list-item-title>Recommended</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        style="
                          color: #9747ff;
                          font-size: 16px;
                          font-style: normal;
                          font-weight: 400;
                          line-height: 33.492px;
                        "
                      >
                        <template v-slot:prepend>
                          <v-icon icon="mdi-checkbox-blank-circle"></v-icon>
                        </template>

                        <v-list-item-title
                          >Milk has coagulated</v-list-item-title
                        >
                      </v-list-item>
                    </v-list>
                  </div>
                </div>

                <linear-guage
                  :acidityRawMilkOrGravityValue="acidityRawMilkOrGravityValue"
                  :dialogCode="dialogCode"
                />

                <div class="d-flex flex-column">
                  <div class="p-2" style="margin-left: 16px">
                    <span
                      style="
                        color: #2e63a3;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: normal;
                        letter-spacing: 0.8px;
                      "
                      >Important Note</span
                    >
                    <v-divider style="margin-top: 10px"></v-divider>
                  </div>

                  <div class="p-2" style="margin-left: 16px">
                    <p
                      class="mt-5"
                      style="
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 33.492px;
                      "
                    >
                      Acidity of raw milk is the % of lactic acid in the milk.
                      Fresh cow's milk has a pH around 6.7-6.9. Values greater
                      than 6.9 indicates that the milk has coagulated and a
                      value below 6.6 indicates the presence of colostrum or
                      bacterial contamination.
                    </p>
                  </div>
                </div>
              </v-card>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </v-container>
  </div>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import LinearGuage from "./LinearGuage.vue";

export default {
  data() {
    return {
      sliderValue: [30, 70], // Initial range values
      background: "transparent",
      orientation: "Horizontal",
      value: 10,
      height: 15,
      width: 15,
      offset: -40,
      markerType: "Triangle",
      placement: "Near",
      majorTicks: {
        interval: 10,
        height: 20,
        color: "#9E9E9E",
      },
      minorTicks: {
        interval: 2,
        height: 10,
        color: "#9E9E9E",
      },
      labelStyle: {
        offset: 48,
        font: {
          fontFamily: "inherit",
        },
      },
      axisIndex: 0,
      axisValue: 10,
      positionX: 10,
      positionY: -70,
      zIndex: "1",

      titles: {
        "acidity-raw-milk": "Acidity Raw Milk (ph)",
        "specific-gravity": "Specific Gravity (at std. Temperature)",
      },
    };
  },
  components: {
    "linear-guage": LinearGuage,
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
    titleHeading() {
      return this.titles[this.dialogCode];
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
    dialogCode: {
      type: String,
      required: true,
    },
    acidityRawMilkOrGravityValue: {
      type: Number,
      required: true,
    },
    acidityRawMilkOrGravityResult: {
      type: String,
      required: true,
    },
  },
  mixins: [loadingMixin],
  methods: {
    closeModal() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style scoped>
::v-deep .v-text-field--enclosed .v-input__append-inner {
  margin-top: 10px;
}

::v-deep .v-input__control fieldset {
  border: none;
}
::v-deep .v-input__slot fieldset:first-child {
  border-top: 1px solid #bbb;
}
::v-deep .v-form span:last-child .v-input__slot fieldset {
  border-bottom: 1px solid #bbb;
}
::v-deep .highlightedInput {
  border: 1px solid #00bd73;
  border-width: 1px 0 1px 0;
  border-radius: 0;
}

.text--success {
  color: #198754;
}
.text--yellow {
  color: #ffc107;
}

.text--danger {
  color: #dc3545;
}

.text--primary {
  color: #2e63a3;
}

.sub-content {
  font-size: 16px;
}

.main-content {
  font-size: 18px;
  font-weight: bold;
}

.micro-flex {
  width: 667px;
  /* height: 88px; */
  flex-shrink: 0;
  background: var(--neutral-5, rgba(243, 243, 243, 0.5));
  padding: 20px;
  margin-top: 20px;
}
</style>
